module.exports = __webpack_public_path__ + "static/media/progress-gems.088fe630.svg";